    <!--<form [formGroup]="form" class="row">
 Caso Validacion saime  -->
    <!-- <mat-form-field class="col-6" appearance="outline">
        <mat-label>No Cédula de Candidato</mat-label>
        <input disabled  matInput [value]="ci">
      </mat-form-field>
    <mat-form-field class="col-6" appearance="outline">
        <mat-label>Nombres y APellidos Candidato</mat-label>
        <input disabled  matInput [value]="nombre">
    </mat-form-field> 

</form>-->


<div class="row margin">
    <!-- <div class="col-6 flex">
        <p class="text">Cliente:</p>{{nombre}}
    </div>
    <div class="col-6 flex">
        <p class="text">C.I:</p>{{ci}}
    </div> -->
    <div class="col-12">
        <form [formGroup]="form">
            <div class="opcionCheck ">
                <p class="texto">Verificado en Saime</p>
                <mat-checkbox formControlName="validar" ></mat-checkbox>
              </div>
        </form>
    </div>
</div>